<template>
	<div class="m-auto" style="max-width:1300px">
		<div class="back-step" @click="backStep">
			<icon name="arrow-left" />{{$t('planesYPrecios.regresar')}}
		</div>
    	<h6 class="sub-title">{{$t('planesYPrecios.paso-2.titulo')}}<span>{{$t('planesYPrecios.paso-2.subTitulo')}}</span></h6>
		<div class="cards-wrap" style="max-width: 608px">
			<div class="card card_object" :class="(item.name === GoalsConstants.OBJETIVO_4 && item.id === goalSelected.id && examSelected.id != 0 ) || (item.name != GoalsConstants.OBJETIVO_4 && item.id === goalSelected.id) ? 'active' : null" @click="item.name === GoalsConstants.OBJETIVO_4 ? $bvModal.show('modal-courses') : null; selectedGoal(item);" v-for="item in goals" :key="item.id" :id="'goal_'+item.id">
				<div class="card-body">
					 <img :src="getImage(item.image)"/>
					<p>{{item.name === GoalsConstants.OBJETIVO_4 ? (examSelected.id != 0 ? examSelected.name : $t('planesYPrecios.paso-2.objetivo.' + item.id)) : $t('planesYPrecios.paso-2.objetivo.' + item.id)}} 
						<!-- <span class="material-icons-outlined ml-1" v-if="item.name === GoalsConstants.OBJETIVO_4 ?true:false" v-b-tooltip.hover.right title="Texto">info</span> -->
					</p>
				</div>
			</div>
		</div>
		<div class="text-center mt-5">
			<b-button variant="primary" :disabled="!FlagSeleccionado"  @click="send();">{{$t('planesYPrecios.paso-2.button')}}</b-button>
		</div>
		<div class="contact">
			<p>{{$t('planesYPrecios.paso-2.footer')}}</p>
			<div class="links">
				<b-link :href="'mailto:'+ CONSTANTES.EMAIL">
					<icon name="msg" />
					<span>{{CONSTANTES.EMAIL}}</span>
				</b-link>
				<b-link :href="'https://wa.me/' + CONSTANTES.WHATSAPP_URL" target="_blank">
					<icon name="whatsapp" />
					<span>{{CONSTANTES.WHATSAPP}}</span>
				</b-link>
			</div>
		</div>
		<SeleccionExamen :Age="studentData.age" :exam="examSelected" @saveExamSelected="saveExamSelected" :FlagExamenSeleccionado="FlagExamenSeleccionado"/>
	</div>
</template>
<script>
	import SeleccionExamen from '@/components/modals/seleccion'
	import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
    import { OBJETIVOS, CONSTANTES} from '@/assets/js/appConstants'; 
	import { ValidateIsPlanActive, hideSidebar } from '@/assets/js/util.js';

	export default {
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				GoalsConstants :OBJETIVOS,
				CONSTANTES: CONSTANTES,
				FlagSeleccionado:false,
				FlagExamenSeleccionado:false,
				goalSelected: {
					name: '',
					id: 0
				},
				examSelected: {
					name: '',
					id: 0,
                    programId: 0
				},
				data: {
					goal: {},
					exam: {}
				}
			}
		},
		components:{
			SeleccionExamen
		},
		computed: { 
			UserId: {
				get() {
					return this.$store.state.user_id;
				},
			},
			User: {
				get() {
					return this.$store.state.user;
				},
				set(value) {
					this.$store.commit('mutateUser', value);
				}
			},
		},
		async created() {
		 	let planActive  = await  ValidateIsPlanActive(this.User.personStudentId, this.$store.state.authToken); 
			 
			if(!planActive){
				hideSidebar(this.User, 1, this.$store.state.datosSidebar) 

				this.goalSelected = this.goalData == null ? {name: '', id: 0} :  this.goalData;
				this.examSelected = this.examData == null ? {name: '', id: 0, programId: 0} :  this.examData;;
				if(this.goalSelected != null && this.goalSelected.id != 0){
					this.FlagSeleccionado = true;
				}

			}else{
				this.$router.push({ name: `dashboard` }).catch(err => {}); 
			}
			
		},
		methods:{
			
			selectedGoal: function(goal){
				if (goal.id != this.GoalsConstants.OBJETIVO_4) {
                    this.FlagSeleccionado = true;
					this.FlagExamenSeleccionado = false;
					this.examSelected = {
						name: '',
						id: 0,
						programId: 0
					};
 
				} 
				else
				{
					this.FlagSeleccionado = false;
				}
				
				this.goalSelected = {
					name: goal.name,
					description: goal.description,
					id: goal.id,
					image: goal.image
				}
				/*this.goals.forEach(element => {
					if (element.id == goal.id) {
						this.goalSelected = {
							name: element.name,
							id: element.id
						};
					}
				});
				*/
			},
			getImage(value) {
				return require(`@/assets/img/${value}`);
			},
			saveExamSelected: function(dataExam){
				this.FlagExamenSeleccionado = true;
				this.examSelected = dataExam
				this.FlagSeleccionado = true;
				this.hideModal('modal-courses');
			},
			/*saveExam: function(){
				this.FlagSeleccionado = true;
				this.selected = {
					name: this.examSelected.name,
					id: this.examSelected.id,
					programId:this.examSelected.programId
				};
			
			},*/
			hideModal:function(id){
				this.$root.$emit('bv::hide::modal',id)
			},
			send() {
				this.FlagSeleccionado = false;
				let dataPost = {
					Id: this.User.groupId,
					GoalId: this.goalSelected.id,
					SubjectId: this.examSelected != null && this.examSelected.id != 0 ? this.examSelected.id : null ,// 0 o null = null, 
					PersonStudentId: this.User.personStudentId,
					userCreated: this.User.email
				}
      			
				baseInstanceAxios
				.post(this.API_URL + `/Resources/Groups/SaveGoalPreview`, dataPost)
				.then(response => {
					if (response.data != null  ) {
						this.data = {
							goal: this.goalSelected,
							exam: this.examSelected
						}
						this.$emit('listenChild', this.data);

						this.nextStep();
					}
				});

				
			},
		},
		props: {
			nextStep: {
				type: Function,
				default() {
					return {}
				}
			},
			backStep: {
				type: Function,
				default() {
					return {}
				}
			},
			goals: {
				type: Array
			},
			studentData:{
				type: Object
			},
			goalData:{
				type: Object
			},
			examData:{
				type: Object
			}
		}
	}
</script>